import { CNP_RCS_CAMPAIGN_DETAILS_PATH } from '@/constants/paths';
import { capitalize, snakeToTitleCase } from '@/utils';
import { convertTimeWithTimezone } from '@/utils/time';
import { UsecaseType } from '@/utils/types';
import { BoxV2 as Box } from 'portal-commons';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { CnpCampaignListItem } from '../../types';
import { remapTCRStatus } from '../../utils';

interface Props {
  campaign: CnpCampaignListItem;
  rcsUseCases: UsecaseType[];
}

const AcceptedRcsCnpCampaignListingRow: React.FC<Props> = ({
  campaign,
  rcsUseCases,
}) => {
  const history = useHistory();
  const location = useLocation();
  const handleRowClick = () => {
    history.push({
      pathname: CNP_RCS_CAMPAIGN_DETAILS_PATH.replace(':id', campaign.uid),
      state: {
        goBackPage: location.pathname + location.search,
      },
    });
  };
  const displayUsecase = (usecaseId: string) => {
    const usecase = rcsUseCases.find((useCase) => useCase.id === usecaseId);
    return usecase ? usecase.displayName : usecaseId;
  };

  return (
    <Box as="tr" data-testid="campaignRow" onClick={handleRowClick}>
      <Box as="td" sx={{ width: 100, minWidth: 100 }} data-testid="campaignUid">
        {campaign.uid}
      </Box>
      {/* <Box
        as="td"
        sx={{ width: 150, minWidth: 150 }}
        data-testid="campaignDisplayName"
      >
        {campaign.displayName}
      </Box> */}
      <Box
        as="td"
        sx={{ width: 80, minWidth: 80 }}
        data-testid="campaignBrandUid"
      >
        {campaign.brandUid}
      </Box>
      <Box
        as="td"
        sx={{ width: 100, minWidth: 100 }}
        data-testid="campaignUsecase"
      >
        {displayUsecase(campaign.usecase)}
      </Box>
      <Box
        as="td"
        sx={{ width: 120, minWidth: 120 }}
        data-testid="campaignBillingCategory"
      >
        {snakeToTitleCase(campaign.billingCategory)}
      </Box>
      <Box
        as="td"
        sx={{ width: 150, minWidth: 150, wordBreak: 'break-all' }}
        data-testid="campaignDownstreamCnpName"
      >
        {campaign.downstreamCnpName}
      </Box>
      <Box
        as="td"
        sx={{ width: 110, minWidth: 110 }}
        data-testid="campaignSharedOnDate"
      >
        {convertTimeWithTimezone(
          campaign.sharedOnDate,
          undefined,
          'MM/DD/YYYY'
        )}
      </Box>
      <Box
        as="td"
        sx={{ width: 150, minWidth: 150, wordBreak: 'break-all' }}
        data-testid="campaignUpstreamCnpName"
      >
        {campaign.upstreamCnpName}
      </Box>
      <Box
        as="td"
        sx={{ width: 110, minWidth: 110 }}
        data-testid="campaignSharedToDate"
      >
        {convertTimeWithTimezone(
          campaign.sharedToDate,
          undefined,
          'MM/DD/YYYY'
        )}
      </Box>
      <Box
        as="td"
        sx={{ width: 90, minWidth: 90 }}
        data-testid="campaignStatus"
      >
        {remapTCRStatus(campaign.status)}
      </Box>
      <Box
        as="td"
        sx={{ width: 110, minWidth: 110 }}
        data-testid="campaignSharedToStatus"
      >
        {campaign?.sharedToStatus}
      </Box>
    </Box>
  );
};

export default AcceptedRcsCnpCampaignListingRow;
